import { GradeMaterials } from 'src/app/shared/models/grade-materials.model';

export const GRADES_7_8_MATERIALS: GradeMaterials = {
  categories: [
    {
      headingEn: 'Introductory items',
      headingEs: 'Elementos introductorios',
      items: [
        {
          id: 'program-guide-7-8',
          labelEn: 'Program Guide 7—8',
          labelEs: 'Guía del programa 7—8',
          subLabelEn: 'website\'s program section',
          subLabelEs: 'sección del programa de la página de web',
          filePath: 'assets/printables/en/7-8/Program_Guide_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Program_Guide_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-parents-7-8',
          labelEn: 'Letter to parents',
          labelEs: 'Carta para los padres',
          filePath: 'assets/printables/en/7-8/Letter_Parents_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Letter_Parents_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'letter-administrator-7-8',
          labelEn: 'Letter to administrator',
          labelEs: 'Carta para los administradores',
          filePath: 'assets/printables/en/7-8/Letter_Administrator_7-8.docx',
          filePathEs: 'assets/printables/es/7-8/Letter_Administrator_7-8_ES.docx',
          iconType: 'doc'
        },
        {
          id: 'letter-donation-7-8',
          labelEn: 'Donation request letter',
          labelEs: 'Carta de solicitud para donaciones',
          filePath: 'assets/printables/en/7-8/Letter_Donation_Request_7-8.docx',
          filePathEs: 'assets/printables/es/7-8/Letter_Donation_Request_7-8_ES.docx',
          iconType: 'doc'
        }
      ]
    },
    {
      headingEn: 'Employment',
      headingEs: 'Empleo',
      items: [
        {
          id: 'payday-video-7-8',
          labelEn: 'Payday video',
          labelEs: 'Video sobre el día de pago',
          filePath: 'assets/video/CE_S01.mp4',
          filePathEs: 'assets/video/CE_S01.mp4',
          iconType: 'video'
        },
        {
          id: 'job-application-7-8',
          labelEn: 'Job application',
          labelEs: 'Aplicación de trabajo',
          filePath: 'assets/printables/en/7-8/Job_Application_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Job_Application_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-offer-7-8',
          labelEn: 'Job offer',
          labelEs: 'Oferta de trabajo',
          filePath: 'assets/printables/en/7-8/Job_Offer_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Job_Offer_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'job-posters-7-8',
          labelEn: 'Job posters',
          labelEs: 'Afiches de trabajo',
          filePath: 'assets/printables/en/7-8/Job_Posters_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Job_Posters_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'paycheck-7-8',
          labelEn: 'Paychecks',
          labelEs: 'Sueldo',
          filePath: 'assets/printables/en/7-8/Paycheck_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Paycheck_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'business-license-7-8',
          labelEn: 'Business license',
          labelEs: 'Licencia de negocios',
          filePath: 'assets/printables/en/7-8/Business_License_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Business_License_7-8_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Banking',
      headingEs: 'Bancario/a',
      items: [
        {
          id: 'bank-slip-7-8',
          labelEn: 'Bank slips',
          labelEs: 'Recibos bancarios',
          filePath: 'assets/printables/en/7-8/Bank_Slip_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Bank_Slip_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bank-log-7-8',
          labelEn: 'Classroom bank log',
          labelEs: 'El registro de banco para la clase',
          filePath: 'assets/printables/en/7-8/Bank_Log_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Bank_Log_7-8_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Fines',
      headingEs: 'Multas',
      items: [
        {
          id: 'fine-ticket-7-8',
          labelEn: 'Fine tickets',
          labelEs: 'Tiquetes de multa',
          filePath: 'assets/printables/en/7-8/Fine_Ticket_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Fine_Ticket_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'offense-log-7-8',
          labelEn: 'Offense log',
          labelEs: 'Registro de ofensas',
          filePath: 'assets/printables/en/7-8/Offense_Log_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Offense_Log_7-8_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Cash',
      headingEs: 'Dinero',
      items: [
        {
          id: 'bills-50-7-8',
          labelEn: '$50 bills',
          labelEs: 'Billetes de $50',
          subLabelEn: 'small bills: see grades 2—3',
          subLabelEs: 'facturas pequeñas: refiera los grados 2-3',
          filePath: 'assets/printables/en/7-8/Bills_50_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Bills_50_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-100-7-8',
          labelEn: '$100 bills',
          labelEs: 'Billetes de $100',
          filePath: 'assets/printables/en/7-8/Bills_100_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Bills_100_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'bills-500-7-8',
          labelEn: '$500 bills',
          labelEs: 'Billetes de $500',
          filePath: 'assets/printables/en/7-8/Bills_500_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Bills_500_7-8_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Rent & deeds',
      headingEs: 'Alquiler y título de propiedad',
      items: [
        {
          id: 'rental-agreement-7-8',
          labelEn: 'Rental agreement',
          labelEs: 'Contrato de alquiler',
          filePath: 'assets/printables/en/7-8/Rental_Agreement_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Rental_Agreement_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'rent-log-7-8',
          labelEn: 'Rent log',
          labelEs: 'Registro de alquiler',
          filePath: 'assets/printables/en/7-8/Rent_Log_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Rent_Log_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'unpaid-rent-notice-7-8',
          labelEn: 'Unpaid rent notice',
          labelEs: 'Aviso de renta no pagada',
          filePath: 'assets/printables/en/7-8/Unpaid_Rent_Notice_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Unpaid_Rent_Notice_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'desk-deed-7-8',
          labelEn: 'Deed to desk',
          labelEs: 'Título de propiedad del escritorio',
          filePath: 'assets/printables/en/7-8/Desk_Deed_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Desk_Deed_7-8_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Bills & taxes',
      headingEs: 'Cuentas e impuestos',
      items: [
        {
          id: 'bill-pay-log-7-8',
          labelEn: 'Classroom bill pay log',
          labelEs: 'Registro de cuentas pagadas de la clase',
          filePath: 'assets/printables/en/7-8/Bill_Pay_Log_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Bill_Pay_Log_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'energy-log-7-8',
          labelEn: 'Classroom energy log',
          labelEs: 'Registro de energía de la clase',
          filePath: 'assets/printables/en/7-8/Energy_Log_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Energy_Log_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'tax-record-7-8',
          labelEn: 'Tax record form',
          labelEs: 'Documento de registro de impuestos',
          filePath: 'assets/printables/en/7-8/Tax_Record_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Tax_Record_7-8_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Auctions',
      headingEs: 'Subastas',
      items: [
        {
          id: 'auction-video-7-8',
          labelEn: 'Auction video',
          labelEs: 'Video sobre subastas',
          filePath: 'assets/video/CE_S04.mp4',
          filePathEs: 'assets/video/CE_S04.mp4',
          iconType: 'video'
        },
        {
          id: 'auction-record-7-8',
          labelEn: 'Auction record form',
          labelEs: 'Forma de registro de subasta',
          filePath: 'assets/printables/en/7-8/Auction_Record_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Auction_Record_7-8_ES.pdf',
          iconType: 'pdf'
        },
        {
          id: 'auction-paddle-7-8',
          labelEn: 'Auction paddle',
          labelEs: 'Paleta de subastas',
          filePath: 'assets/printables/en/7-8/Auction_Paddle_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Auction_Paddle_7-8_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Year-end certificates',
      headingEs: 'Certificados de fin de año',
      items: [
        {
          id: 'saver-certs-7-8',
          labelEn: 'Saver certificates (Includes Saver, Super, and Ultimate awards)',
          labelEs: 'Certificado de ahorro (Incluye los premios Saver, Super y Ultimate)',
          filePath: 'assets/printables/en/7-8/Saver_Certs_7-8.pdf',
          filePathEs: 'assets/printables/es/7-8/Saver_Certs_7-8_ES.pdf',
          iconType: 'pdf'
        }
      ]
    },
    {
      headingEn: 'Posters & handouts',
      headingEs: 'Afiches y folletos',
      items: [
        {
          id: 'bonus-list-7-8',
          labelEn: 'Bonus list',
          labelEs: 'Lista de bonificaciones',
          filePath: 'assets/printables/en/7-8/Bonus_List_7-8.docx',
          filePathEs: 'assets/printables/es/7-8/Bonus_List_7-8_ES.doc',
          iconType: 'doc'
        },
        {
          id: 'fine-list-7-8',
          labelEn: 'Fine list',
          labelEs: 'Lista de multas',
          filePath: 'assets/printables/en/7-8/Fine_List_7-8.docx',
          filePathEs: 'assets/printables/es/7-8/Fine_List_7-8_ES.doc',
          iconType: 'doc'
        }
      ]
    }
  ],
  supplies: {
    headingEn: 'Supplies to have on hand',
    headingEs: 'Suministros para tener al alcance',
    items: [
      { labelEn: 'Envelopes', labelEs: 'Sobres' },
      { labelEn: 'Portfolio folders', labelEs: 'Carpetas de portafolios' },
      { labelEn: 'Cash drawer or box', labelEs: 'Caja de dinero' },
      { labelEn: 'Popsicle sticks for auction paddles', labelEs: 'Palos de paleta para las paletas de subasta' },
      { labelEn: 'Sticky notes', labelEs: 'Notas adhesivas' },
      { labelEn: 'Clipboard', labelEs: 'Portapapeles' },
      { labelEn: 'Auction items', labelEs: 'Artículos de subasta' }
    ]
  }
};
